import React, { useMemo } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import useClientAutocomplete from '@src/hooks/useClientAutocomplete';

const ClientDropdown = ({ value, onChange, label = 'Select Client' }) => {
  const {
    options,
    loading,
    handleInputChange,
  } = useClientAutocomplete();

  const selectedOption = useMemo(() => {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    return (
      options.find((option) => String(option.value) === String(value)) || null
    );
  }, [options, value]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={options}
      loading={loading}
      value={selectedOption}
      onChange={(_, option) => onChange(option?.value ?? '')}
      onInputChange={handleInputChange}
      isOptionEqualToValue={(option, selected) =>
        String(option.value) === String(selected?.value)
      }
      getOptionLabel={(option) => option?.label || ''}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={16} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ClientDropdown;
